export const coordinateUtils = {
    // Helper to parse Point type from Supabase
    // Postgres Point: "(x,y)" string, or sometimes object {x,y} depending on client config
    parseCoordinates(coordData) {
        if (!coordData) return null;

        // 1. If it's already an array [lng, lat]
        if (Array.isArray(coordData)) {
            if (coordData.length === 2 && !isNaN(coordData[0]) && !isNaN(coordData[1])) {
                return coordData;
            }
            return null;
        }

        // 2. If it's a string "(lng,lat)"
        if (typeof coordData === 'string') {
            const clean = coordData.replace(/[()]/g, '');
            const parts = clean.split(',');
            if (parts.length === 2) {
                const lng = parseFloat(parts[0]);
                const lat = parseFloat(parts[1]);
                if (!isNaN(lng) && !isNaN(lat)) {
                    return [lng, lat];
                }
            }
        }

        // 3. If it's an object {x: lng, y: lat} or {lng, lat}
        if (typeof coordData === 'object') {
            const lng = coordData.x !== undefined ? coordData.x : coordData.lng;
            const lat = coordData.y !== undefined ? coordData.y : coordData.lat; // Note: Postgres uses (x,y) -> (lng,lat) standard
            if (lng !== undefined && lat !== undefined && !isNaN(lng) && !isNaN(lat)) {
                return [parseFloat(lng), parseFloat(lat)];
            }
        }

        return null; // Invalid format
    },

    // Convert [lng, lat] array to PostgreSQL POINT string format "(lng,lat)"
    toPointString(coordData) {
        if (!coordData) return null;

        // If it's an array [lng, lat]
        if (Array.isArray(coordData) && coordData.length === 2) {
            const lng = parseFloat(coordData[0]);
            const lat = parseFloat(coordData[1]);
            if (!isNaN(lng) && !isNaN(lat)) {
                return `(${lng},${lat})`;
            }
        }

        // If it's already a string in "(lng,lat)" format, return as-is
        if (typeof coordData === 'string' && coordData.startsWith('(')) {
            return coordData;
        }

        // If it's an object {lng, lat}
        if (typeof coordData === 'object' && coordData.lng !== undefined && coordData.lat !== undefined) {
            return `(${coordData.lng},${coordData.lat})`;
        }

        return null;
    },

    /**
     * Checks if coordinates are within the specified maxBounds.
     * @param {Array} coordinates - [lng, lat]
     * @param {Array} maxBounds - [[west, south], [east, north]]
     * @returns {boolean}
     */
    isWithinBounds(coordinates, maxBounds) {
        if (!coordinates || !maxBounds || maxBounds.length !== 2) return true;

        const [lng, lat] = coordinates;
        const [[west, south], [east, north]] = maxBounds;

        return (
            lng >= west &&
            lng <= east &&
            lat >= south &&
            lat <= north
        );
    }
};
